<script>
import { TabItemsDirective, TabItemDirective } from "@syncfusion/ej2-vue-navigations/src/tab/items.directive";
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { controlStore, createStoreIndex, } from "@common/control/controlStore.js";
import { library } from "@common/library/library";
// import { TabItemsDirective, TabItemDirective } from "@syncfusion/ej2-vue-navigations";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {
    panel1: {
        type: 'panel',
        label: 'Tabs',
        id: 'panel1',
        fields: [
            'useParamTabsList',
            'isWizard',
            'useVueSlot',
            'tabs',
        ]
    },
    panel2: {
        type: 'panel',
        label: 'Footer',
        id: 'panel2',
        fields: [
            'showFooter',
            'showFooterWhen',
            'footerCustomTemplate',
            'footerColor',
            'buttons'
        ]
    },
    useParamTabsList: {
        type: 'boolean',
        label: 'Use Params to Define Tabs',
        id: 'useParamTabsList',
        default: false
    },
    isWizard: {
        type: 'boolean',
        label: 'Show as Wizard',
        id: 'isWizard',
        default: false
    },
    useVueSlot: {
        type: 'boolean',
        label: 'Use Vue Slots',
        id: 'useVueSlot',
        default: false,
        helpText: 'Select this setting if you plan to use this component inside another component, or as part of a template.'
    },
    showFooter: {
        type: 'boolean',
        label: 'Show Footer',
        helpText: 'Shows the footer.',
        id: 'showFooter',
        default: false
    },
    showFooterWhen: {
        label: 'Show When',
        id: 'showFooterWhen',
        type: 'logicEditor',
        helpText: 'Only show footer when this logic criteria is met.',
        default: [],
        otherProps: {
            hideStandardRecordTypes: true,
            recordTypes: [
                { text: 'Tab List', value: 'self' },
            ],
            defaultRecordType: 'self'
        }
    },
    footerCustomTemplate: {
        type: 'text',
        id: 'customTemplate',
        label: 'Custom template',
        default: '',
    },
    footerColor: {
        type: 'OBJECT',
        id: 'color',
        label: 'Color settings',
        default: {
            backgroundColor: "transparent",
            textColor: "black",
            borderColor: "transparent"
        },
        properties: {
            backgroundColor: {
                type: 'color',
                id: 'backgroundColor',
                label: 'Background Color',
                default: 'transparent'
            },
            textColor: {
                type: 'color',
                id: 'textColor',
                label: 'Text Color',
                default: 'black'
            },
            borderColor: {
                type: 'color',
                id: 'borderColor',
                label: 'Border Color',
                default: 'transparent'
            },
        }
    },
    buttons: {
        type: 'ARRAY',
        id: 'buttons',
        label: 'Buttons',
        default: [
            {
                "id": "back",
                "name": "back",
                "type": "button",
                "label": "Back",
                "color": {
                    "backgroundColor": "white",
                    "textColor": "#f3f7f9",
                    "borderColor": "#f3f7f9"
                },
                "showIcon": true,
                "iconCss": "e-arrow-left",
                "iconPosition": "Left"
            },
            {
                "id": "cancel",
                "name": "cancel",
                "type": "button",
                "label": "Cancel",
                "cssClass": "e-link",
                "color": {
                    "backgroundColor": "transparent",
                    "textColor": "black",
                    "borderColor": "transparent"
                },
            },
            {
                "id": "next",
                "name": "next",
                "type": "button",
                "label": "Next",
                "color": {
                    "backgroundColor": "#f3f7f9",
                    "textColor": "white",
                    "borderColor": "#f3f7f9"
                },
                "showIcon": true,
                "iconCss": "e-arrow-right",
                "iconPosition": "Right"
            },
            {
                "id": "finish",
                "name": "finish",
                "type": "button",
                "label": "Finish",
                "onclick": "finish",
                "color": {
                    "backgroundColor": "#f3f7f9",
                    "textColor": "white",
                    "borderColor": "#f3f7f9"
                }
            }
        ],
        itemConfig: {
            primaryKey: 'label',
            itemType: 'object',
            permissions: {
                canMove: false,
                canDelete: false,
                allowAddItem: false
            },
            keys: {
                id: {
                    type: 'string',
                    label: 'Button ID',
                    id: 'id',
                    display: false,
                    disabled: true,
                    default: 'back'
                },
                name: {
                    type: 'string',
                    label: 'Button Name',
                    id: 'name',
                    display: false,
                    disabled: true,
                    default: 'back'
                },
                type: {
                    type: 'string',
                    label: 'Type',
                    id: 'type',
                    display: false,
                    disabled: true,
                    default: 'button'
                },
                label: {
                    type: 'string',
                    id: 'label',
                    label: 'Label',
                    default: ''
                },
                color: {
                    type: 'OBJECT',
                    id: 'color',
                    label: 'Color settings',
                    default: {
                        backgroundColor: "transparent",
                        textColor: "black",
                        borderColor: "transparent"
                    },
                    properties: {
                        backgroundColor: {
                            type: 'color',
                            id: 'backgroundColor',
                            label: 'Background Color',
                            default: 'transparent'
                        },
                        textColor: {
                            type: 'color',
                            id: 'textColor',
                            label: 'Text Color',
                            default: 'black'
                        },
                        borderColor: {
                            type: 'color',
                            id: 'borderColor',
                            label: 'Border Color',
                            default: 'transparent'
                        },
                    }
                },
                showIcon: {
                    type: 'boolean',
                    id: 'label',
                    label: 'Show Icon',
                    default: false
                },
                iconCss: {
                    type: 'string',
                    id: 'iconCss',
                    label: 'Icon CSS Classes',
                    default: ''
                },
                iconPosition: {
                    type: 'dropdown',
                    id: 'iconPosition',
                    label: 'Icon Position',
                    fields: { text: 'text', value: 'value' },
                    items: [
                        { text: 'Top', value: 'Top' },
                        { text: 'Right', value: 'Right' },
                        { text: 'Bottom', value: 'Bottom' },
                        { text: 'Left', value: 'Left' },
                    ],
                    default: 'Top'
                }
            }
        }
    },
    tabs: {
        type: 'ARRAY',
        id: 'tabs',
        label: 'Tabs',
        default: [],
        itemConfig: {
            primaryKey: 'title',
            itemType: 'object',
            permissions: {
                canMove: true,
                canDelete: true,
                allowAddItem: true
            },
            keys: {
                title: {
                    type: 'string',
                    id: 'title',
                    label: 'Tab Title',
                    default: ''
                },
                showWhen: {
                    label: 'Show Tab When',
                    id: 'showWhen',
                    type: 'logicEditor',
                    helpText: 'Show the tab when this logic criteria is met.',
                    default: [],
                    otherProps: {
                        hideStandardRecordTypes: true,
                        recordTypes: [
                            { text: 'Tab Record', value: 'component.record' },
                            { text: 'Tab Component', value: 'self' },
                        ],
                        defaultRecordType: 'self'
                    }
                },
                completeWhen: {
                    label: 'Complete Tab When',
                    id: 'completeWhen',
                    type: 'logicEditor',
                    default: [],
                    otherProps: {
                        hideStandardRecordTypes: true,
                        recordTypes: [
                            { text: 'Tab Record', value: 'component.record' },
                            { text: 'Tab Component', value: 'self' },
                        ],
                        defaultRecordType: 'self'
                    }
                },
                color: {
                    type: 'OBJECT',
                    id: 'color',
                    label: 'Color settings',
                    default: {
                        backgroundColor: "transparent",
                        textColor: "black",
                        borderColor: "transparent"
                    },
                    properties: {
                        backgroundColor: {
                            type: 'color',
                            id: 'backgroundColor',
                            label: 'Background Color',
                            default: 'transparent'
                        },
                        textColor: {
                            type: 'color',
                            id: 'textColor',
                            label: 'Text Color',
                            default: 'black'
                        },
                        borderColor: {
                            type: 'color',
                            id: 'borderColor',
                            label: 'Border Color',
                            default: 'transparent'
                        },
                    }
                },
                showIcon: {
                    type: 'boolean',
                    id: 'label',
                    label: 'Show Icon',
                    default: false
                },
                iconCss: {
                    type: 'string',
                    id: 'iconCss',
                    label: 'Icon CSS Classes',
                    default: ''
                },
                iconColor: {
                    type: 'OBJECT',
                    id: 'iconColor',
                    label: 'Icon Color settings',
                    default: {
                        backgroundColor: "transparent",
                        textColor: "black",
                        borderColor: "transparent"
                    },
                    properties: {
                        backgroundColor: {
                            type: 'color',
                            id: 'backgroundColor',
                            label: 'Background Color',
                            default: 'transparent'
                        },
                        textColor: {
                            type: 'color',
                            id: 'textColor',
                            label: 'Text Color',
                            default: 'black'
                        },
                        borderColor: {
                            type: 'color',
                            id: 'borderColor',
                            label: 'Border Color',
                            default: 'transparent'
                        },
                    }
                },
                iconPosition: {
                    type: 'dropdown',
                    id: 'iconPosition',
                    label: 'Icon Position',
                    fields: { text: 'text', value: 'value' },
                    items: [
                        { text: 'Top', value: 'Top' },
                        { text: 'Right', value: 'Right' },
                        { text: 'Bottom', value: 'Bottom' },
                        { text: 'Left', value: 'Left' },
                    ],
                    default: 'Top'
                },
                customTemplate: {
                    type: 'text',
                    id: 'customTemplate',
                    label: 'Custom template',
                    default: '',
                },
                components: {
                    type: 'ARRAY',
                    id: 'components',
                    label: 'Components',
                    default: [],
                    itemConfig: {
                        primaryKey: 'cId',
                        itemType: 'object',
                        permissions: {
                            canMove: true,
                            canDelete: true,
                            allowAddItem: true
                        },
                        keys: {
                            cId: {
                                type: 'dropdown',
                                id: 'cId',
                                itemsSource: 'componentStore.getList(true)',
                                fields: { text: 'cId', value: 'cId' },
                                label: 'Component ID',
                                helpText: 'ID of component that should go into this position.',
                                default: 'buildInfo',
                                // eslint-disable-next-line max-len
                                itemTemplate: `<div><div style="font-size: 18px; line-height: 1em; padding-top: 12px; padding-bottom: 10px;">{{data.cTitle}}</div><div style="font-size: 15px; border-bottom: 1px solid #eee; padding-bottom: 12px; line-height: 1em;"><span style="margin-right: 20px; font-weight: bold;">{{data.cType}}</span>{{data.cId}}</div></div>`,
                                allowFiltering: true,
                                filterBarPlaceholder: 'any of title: hospital type: chart id: component_id123',
                                onfiltering(e, a, b, cmp) {
                                    let findMatch = (rgx) => {
                                        let query = e.text.toLowerCase();
                                        let match = rgx.exec(query);
                                        if (match && match.length) {
                                            match = match[0].replace(/title:|type:|id:/g, "");
                                            match = match.trim();
                                        }
                                        return match;
                                    };
                                    let keywords = findMatch(/^(.*?)(?=title:|type:|id:|$)/);
                                    let qType = findMatch(/type:(.*?)(?=title:|id:|$)/);
                                    let qTitle = findMatch(/title:(.*?)(?=type:|id:|$)/);
                                    let qId = findMatch(/id:(.*?)(?=title:|type:|$)/);
                                    let output = cmp.options.filter((opt) => {
                                        if (opt.isMissing) return false;
                                        let cId = opt.cId.toLowerCase();
                                        let cType = opt.cType.toLowerCase();
                                        let cTitle = opt.cTitle.toLowerCase();
                                        return (!qId || cId.indexOf(qId) !== -1)
                                            && (!qType || cType.indexOf(qType) !== -1)
                                            && (!qTitle || cTitle.indexOf(qTitle) !== -1)
                                            && (!keywords || (cId.indexOf(keywords) !== -1
                                                || cTitle.indexOf(keywords) !== -1
                                                || cType.indexOf(keywords) !== -1));
                                    });
                                    e.updateData(output);
                                },
                                message: 'Enter keywords to perform a search across all non-prefixed phrases.  Use prefixes to match specific properties such as "type:", "title:", and "id:". Example - "type: chart title: some chart", or "some keywords type: chart.',
                                secondaryActions: [{
                                    text: 'New Component',
                                    action: 'createComponent',
                                    source: 'actionStore',
                                    params: {},
                                    chain: [{
                                        action: 'setSelectedComponent',
                                        source: 'component',
                                        params: {}
                                    }]
                                }]
                            }
                        },
                        newItem: {
                            cId: 'buildInfo'
                        }
                    }
                }
            },
            newItem: {
                title: '',
                color: {
                    backgroundColor: "transparent",
                    textColor: "black",
                    borderColor: "transparent"
                },
                showIcon: false,
                iconCss: "",
                iconColor: {
                    backgroundColor: "#ff6d53",
                    textColor: "white",
                    borderColor: "#ff6d53"
                },
                iconPosition: "",
                customTemplate: "",
                components: [],
                showWhen: false
            }
        }
    },
};

let tabListConfig = {
    cId: "tabList",
    cType: "tabList",
    cTitle: "Tab List",
    cTemplate: `<div v-if="!loading" :class="{'is-wizard':config.isWizard}" class="tab-list-container">
                    <ejs-tab :id="cId" height="100%" :selected="selectTab" :selected-item="selectedTabIndex" :selecting="selectEvent" :created="created" :ref="cId">
                        <div class="e-tab-header" :class="{'hide-indicator':config.hideIndicator}">
                            <div v-for="(tabItem, index) in tabs" v-show="tabItem.show">
                                <div :style="{
                                                'background-color': tabItem.backgroundColor || '',
                                                'border-color': tabItem.borderColor || '',
                                                'color': tabItem.textColor || ''
                                            }">
                                    <div v-if="tabItem.iconCss === 'bubble'" class="bubble-area">
                                        <div v-if="index !== 0" class="bubble-line-before"></div>
                                        <div v-if="tabItem.iconCss === 'bubble'" class="e-icons bubble-icon"></div>
                                        <div v-if="index !== lastTabIndex" class="bubble-line-after"></div>
                                    </div>
                                    <span v-if="tabItem.showIcon && tabItem.iconCss !== 'bubble' && ( tabItem.iconPosition === 'Top' || tabItem.iconPosition === 'Left' )"
                                          :class="'e-icons e-tab-icon' + (tabItem.iconPosition === 'Top' ? ' e-icon-top ' : ' e-icon-left ' ) + ( tabItem.iconCss ? tabItem.iconCss : '')">
                                    </span>
                                    <div class="tab-list-title" v-html="tabItem.title"></div>
                                    <span v-if="tabItem.showIcon && tabItem.iconCss !== 'bubble' && ( tabItem.iconPosition === 'Right' || tabItem.iconPosition === 'Bottom' )"
                                          :class="'e-icons e-tab-icon' + (tabItem.iconPosition === 'Right' ? ' e-icon-right ' : ' e-icon-bottom ' ) + ( tabItem.iconCss ? tabItem.iconCss : '')">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="e-content">
                            <div v-for="(tabItem, index) in tabs" v-bind:id="'tabList_item_'+index" :key="index" v-show="tabItem.show">
                                <slot v-if="config.useVueSlot" :name="'tabList_item_'+index"></slot>
                                <div v-else>
                                    <div v-if="selectedTabIndex === index"
                                        :style="{
                                                    'background-color': tabItem.contentBackgroundColor || '',
                                                    'border-color': tabItem.contentBorderColor || '',
                                                    'color': tabItem.contentTextColor || ''
                                                }">
                                        <div v-if="tabItem.customTemplate">
                                            <component :is="getCustomTemplateComponent(tabItem.customTemplate)"/>
                                        </div>
                                        <div v-else>
                                            <div v-for="(component, iindex) in tabItem.components" v-bind:id="'tabList_item_'+iindex" :key="iindex">
                                                <div v-if="editorEnabled"><settings-cog :component-id="component.cId" :editor-enabled="editorEnabled" :test-mode="testMode"></settings-cog></div>
                                                <component
                                                    v-bind="componentMappedProps[index][component.cId]"
                                                    v-if="component.cType"
                                                    :is="component.cType"
                                                    :cId="component.cId"
                                                    :editor-enabled="editorEnabled"
                                                    :ref="'ref_' + component.cId"
                                                ></component>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ejs-tab>
                    <div v-if="(config.showFooter || config.isWizard) && showFooter" class="tab-list-footer"
                            :style="{
                                        'background-color': config.footerColor.backgroundColor || '',
                                        'border-color': config.footerColor.borderColor || '',
                                        'color': config.footerColor.textColor || ''
                                    }">
                        <div v-if="config.isWizard" class="fl">
                            <control v-if="selectedTabIndex != 0" name="back"></control>
                        </div>
                        <div v-if="config.isWizard && cancelFunc" class="fl">
                            <control name="cancel"></control>
                        </div>
                        <div v-if="config.isWizard" class="fr">
                            <control v-if="selectedTabIndex != lastTabIndex" name="next"></control>
                        </div>
                        <div v-if="config.isWizard" class="fr">
                            <control v-if="selectedTabIndex === lastTabIndex && typeof finishFunc === 'function'" name="finish"></control>
                        </div>
                        <div v-if="config.showFooter && config.footerCustomTemplate" v-html="config.footerCustomTemplate"></div>
                        <div class="clearfix"></div>
                    </div>
                </div>
               `,
};

let tabListCmp = {
    name: 'tabList',
    editorSettings: editorSettings,
    dataTestIds: [
        {
            search: '.e-template .e-tab-header .e-toolbar-items .e-toolbar-item',
            cData: 'tabs._index_.title',
            suffix: 'header'
        },
        {
            search: '.e-template .e-tab-header .e-content',
            cData: 'tabs._index_.title',
            suffix: 'content'
        }
    ],
    props: {
        loadFunc: {
            required: false
        },
        finishFunc: {
            required: false
        },
        tabChangeFunc: {
            required: false
        },
        validationFunc: {
            required: false
        },
        cancelFunc: {
            required: false
        },
        tabsList: {},
        selectedTab: false,
    },
    data() {
        return {
            selectedTabIndex: 0,
            lastTabIndex: 0,
            tabs: false,
            loading: true,
            showFooter: true,
            tabChecked: false
        };
    },
    computed: {
        componentMappedProps() {
            let output = {};
            if (!this.tabs) return output;
            this.tabs.forEach((tab, index) => {
                if (tab.components) {
                    tab.components.forEach((component) => {
                        if (!output[index]) output[index] = {};
                        output[index][component.cId] = {
                            contextVolId: this.volId || 0,
                            contextOppId: this.oppId || 0,
                            contextOrgId: this.orgId || 0,
                            contextLbeId: this.lbeId || 0,
                            contextSchId: this.schId || 0,
                            contextAeId: this.aeId || 0,
                            contextEntryPointId: this.entryPointId || 0,
                            contextAffId: this.affId || 0,
                            contextDialogId: this.dialogId || 0,
                        };
                    });
                }
            });
            return output;
        }
    },
    updated() {
        this.hideShowTabs();
    },
    watch: {
        tabsList() {
            if (this.config?.useParamTabsList) {
                let allTabs = this.tabsList;
                if (Array.isArray(allTabs) && allTabs.length) {
                    for (let i in allTabs) {
                        if (i === 'length') continue;
                        if (typeof allTabs[i].show === 'undefined') allTabs[i].show = true;
                        if (allTabs[i].showWhen) {
                            library.logicParser.call(this, allTabs[i].showWhen, allTabs[i]);
                        }
                    }
                    // Reload tabs when we add or remove from already initialized tabs list
                    if (!this.loading && Array.isArray(this.tabs) && this.tabs.length !== allTabs.length) {
                        this.loading = true;
                        this.$nextTick(() => {
                            this.loading = false;
                        });
                    }
                    this.tabs = allTabs;
                    this.lastTabIndex = this.config.tabs.length - 1;
                }
            }
        },
        selectedTab(selectedIndex) {
            if (typeof selectedIndex === 'number' && selectedIndex >= 0) this.selectTab({ selectedIndex });
        }
    },
    methods: {
        finish() {
            if (typeof this.finishFunc === 'function') this.finishFunc(this);
        },
        getCustomTemplateComponent(template) {
            let controls = this.controls;
            let _parent = this;
            return {
                template: '<div>' + template + '</div>',
                data() {
                    return {
                        contextVolId: _parent.volId || 0,
                        contextOppId: _parent.oppId || 0,
                        contextOrgId: _parent.orgId || 0,
                        contextLbeId: _parent.lbeId || 0,
                        contextSchId: _parent.schId || 0,
                        contextAeId: _parent.aeId || 0,
                        contextEntryPointId: _parent.entryPointId || 0,
                        contextAffId: _parent.affId || 0,
                        contextDialogId: _parent.dialogId || 0,
                    };
                },
                computed: {
                    controls() {
                        return controls;
                    },
                    recordStore() {
                        return _parent.recordStore;
                    }
                },
                components: {
                    control: controlComponent
                }
            };
        },
        async getcType() {
            // This is used to set the cType so we do not need to keep cType as part of the layoutContainer config
            let promises = [];
            for (let idx in this.tabs) {
                if (idx === 'length') continue;
                if (this.selectedTabIndex !== Number(idx)) continue;
                for (let cIdx in this.tabs[idx].components) {
                    if (cIdx === 'length') continue;
                    let cId = this.tabs[idx].components[cIdx].cId;
                    promises.push(componentStore.getConfig(cId));
                }
            }
            await library.promiseAllSettled(promises).then((responses) => {
                for (let idx in this.tabs) {
                    if (this.selectedTabIndex !== Number(idx)) continue;
                    if (idx === 'length') continue;
                    for (let cIdx in this.tabs[idx].components) {
                        if (cIdx === 'length') continue;
                        let cId = this.tabs[idx].components[cIdx].cId;
                        let compRes = responses.find((res) => res.value && res.value.cId === cId);
                        if (compRes) this.tabs[idx].components[cIdx].cType = compRes.value.cType;
                    }
                }
            });
        },
        async onLoad() {
            if (this.config && this.config.buttons && this.config.buttons.length) {
                let buttons = library.cloneObj(this.config.buttons);
                for (let j in buttons) {
                    if (j === 'length') continue;
                    for (let i in buttons[j].color) {
                        if (i === 'length') continue;
                        buttons[j][i] = buttons[j].color[i];
                    }
                    let controlStoreIndex = createStoreIndex(this.storeId, buttons[j].name);
                    controlStore().addControl(buttons[j], this, controlStoreIndex);
                }
            }
            let allTabs = [];
            if (this.config?.useParamTabsList) {
                allTabs = this.tabsList;
            }
            else if (this.config?.tabs) {
                allTabs = library.cloneObj(this.config.tabs);
            }
            if (Array.isArray(allTabs) && allTabs.length) {
                for (let i in allTabs) {
                    if (i === 'length') continue;
                    if (typeof allTabs[i].show === 'undefined') allTabs[i].show = true;
                    if (allTabs[i].showWhen) {
                        library.logicParser.call(this, allTabs[i].showWhen, allTabs[i]);
                    }
                }
                this.tabs = allTabs;
                this.lastTabIndex = this.config.tabs.length - 1;
            }
            this.loading = false;
            this.$nextTick(() => {
                if (typeof this.loadFunc === 'function') this.loadFunc(this);
            });
            // TODO move this to the selectedTab watcher with "immediate:true" property.  Need to fix componentStore registerModule first
            let selectedIndex = this.selectedTab;
            if (typeof selectedIndex !== 'number') selectedIndex = 0;
            if (selectedIndex >= 0) this.selectTab({ selectedIndex });
        },
        hideShowTabs() {
            for (let i in this.tabs) {
                if (i === 'length') continue;
                if (this.tabs[i].showWhen && this.selectedTabIndex !== i) {
                    library.logicParser.call(this, this.tabs[i].showWhen, this.tabs[i]);
                    if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances) {
                        this.$refs[this.cId].ej2Instances.hideTab(i, !this.tabs[i].show);
                    }
                }
            }
        },
        created() {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.config.isWizard) {
                this.toggleTabsState(1, false);
            }
        },
        toggleTabFinish(toIndex, forse) {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.config.isWizard) {
                for (let i in this.$refs[this.cId].ej2Instances.getTabHeader().ej2_instances[0].tbarEle) {
                    if (i === 'length') continue;
                    if (forse) this.$refs[this.cId].ej2Instances.getTabHeader().ej2_instances[0].tbarEle[i].classList.remove('e-finished');
                    if (i < toIndex) {
                        this.$refs[this.cId].ej2Instances.getTabHeader().ej2_instances[0].tbarEle[i].classList.add('e-finished');
                    }
                }
            }
        },
        toggleTabsState(fromIndex, state) {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.config.isWizard) {
                for (let i = fromIndex; i <= this.lastTabIndex; i++) {
                    this.$refs[this.cId].ej2Instances.enableTab(i, state);
                }
            }
        },
        selectTab: function (e) {
            this.selectedTabIndex = e.selectedIndex;
            this.getcType();
            this.$emit('update:selectedTab', e.selectedIndex);
        },
        selectEvent(e) {
            if (e.isSwiped) e.cancel = true;
            if (this.config.isWizard) {
                if (!this.tabChecked) {
                    e.cancel = true;
                } else {
                    this.tabChecked = false;
                }
            }
        },
        async back(backToIndex) {
            if (isNaN(parseInt(backToIndex, 10))) backToIndex = false;
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.selectedTabIndex - 1 >= 0) {
                let fromIndex = this.selectedTabIndex;
                let toIndex = backToIndex || this.selectedTabIndex - 1;
                let valid = true;
                if (this.config.tabs[this.selectedTabIndex].backWhen) {
                    library.logicParser.call(this, this.config.tabs[this.selectedTabIndex].backWhen, this.config.tabs[this.selectedTabIndex]);
                    valid = this.config.tabs[this.selectedTabIndex].complete;
                } else if (this.config.isWizard && typeof this.validationFunc === 'function') {
                    valid = this.validationFunc(fromIndex, toIndex);
                    if (valid instanceof Promise) valid = await valid;
                }
                if (valid) {
                    this.tabChecked = true;
                    this.selectingTabIndex = toIndex;
                    this.$refs[this.cId].ej2Instances.select(toIndex);
                    this.$nextTick(() => {
                        if (typeof this.tabChangeFunc === 'function') this.tabChangeFunc(fromIndex, toIndex);
                        this.toggleTabFinish(toIndex, true);
                    });
                }
            }
        },
        getFollowingIndex(fromIndex) {
            let followingIndex = fromIndex;
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances) {
                for (let i = fromIndex + 1; i < this.tabs.length; i++) {
                    if (!this.tabs[i].show) continue;
                    followingIndex = i;
                    break;
                }
            }
            return followingIndex;
        },
        clearWizard() {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances) {
                this.tabChecked = true;
                this.toggleTabsState(0, true);
                this.toggleTabsState(1, false);
                this.$refs[this.cId].ej2Instances.select(0);
                this.$nextTick(() => {
                    this.toggleTabFinish(0, true);
                });
            }
        },
        async next() {
            if (this.$refs && this.$refs[this.cId] && this.$refs[this.cId].ej2Instances && this.selectedTabIndex + 1 <= this.$refs[this.cId].ej2Instances.lastIndex) {
                let valid = true;
                let followingIndex = this.getFollowingIndex(this.selectedTabIndex);
                this.selectingTabIndex = followingIndex;
                let fromIndex = this.selectedTabIndex;
                let toIndex = followingIndex;
                if (this.config.tabs[this.selectedTabIndex].completeWhen) {
                    library.logicParser.call(this, this.config.tabs[this.selectedTabIndex].completeWhen, this.config.tabs[this.selectedTabIndex]);
                    valid = this.config.tabs[this.selectedTabIndex].complete;
                } else if (this.config.isWizard && typeof this.validationFunc === 'function') {
                    valid = this.validationFunc(fromIndex, toIndex);
                    if (valid instanceof Promise) valid = await valid;
                }
                if (valid) {
                    this.tabChecked = true;
                    this.$refs[this.cId].ej2Instances.enableTab(followingIndex, true);
                    this.$refs[this.cId].ej2Instances.select(followingIndex);
                    this.$nextTick(() => {
                        this.toggleTabFinish(followingIndex);
                        if (typeof this.tabChangeFunc === 'function') this.tabChangeFunc(fromIndex, toIndex);
                    });
                } else {
                    this.toggleTabsState(followingIndex, false);
                    this.$nextTick(() => {
                        this.toggleTabFinish(followingIndex, true);
                    });
                }
            }
        },
        cancel() {
            if (this.config.isWizard && typeof this.cancelFunc === 'function') {
                this.cancelFunc(this);
            }
        }
    },
    components: {
        "ejs-tab": defineAsyncComponent(() => import('@common/syncfusion/tab')),
        "e-tabitems": TabItemsDirective,
        "e-tabitem": TabItemDirective
    }
};

componentStore.initComponent(tabListCmp, tabListConfig, '@common/tabList/tabList.vue');
export { tabListConfig, tabListCmp };
export default tabListCmp;
</script>

<style scoped>
.fl {
    float: left;
}
.fr {
    float: right;
}
.tab-list-footer {
    padding: 10px;
}

:deep(.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap) {
    padding: 0px;
    text-align: center;
}

:deep(.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .tab-list-title) {
    padding: 0px 18px;
}

:deep(.hide-indicator .e-indicator) {
    display: none !important;
}

.e-tab-header .bubble-area {
    display: flex;
    margin: 20px 0 5px 0;
}

:deep(.is-wizard .e-items) {
    margin: 0 20px !important;
}

.e-tab-header .bubble-line-before, .e-tab-header .bubble-line-after {
    height: 2px;
    background-color: #d3dde6;
    flex-grow: 3;
    margin-top: 9px;
}

.e-tab-header .bubble-icon {
    border-radius: 1000px;
    width: 20px;
    height: 20px;
    border: 2px solid #d3dde6;
}

.e-tab-header .e-item.e-active .bubble-icon {
    border: 2px solid #ff6d53;
}

.e-tab-header .e-active .bubble-icon {
    background-color: transparent;
}

.e-tab-header .e-finished .bubble-line-before,
.e-tab-header .e-active .bubble-line-before,
.e-tab-header .e-finished .bubble-line-after {
    background-color: #ff6d53;
}

.e-tab-header .e-finished .bubble-icon {
    background-color: #ff6d53;
    border-color: #ff6d53;
}

.e-tab-header .e-finished .e-icons.bubble-icon:before {
    content: '\e259' !important;
    font-size: 30px;
    line-height: 18px;
    margin-left: -7px;
    font-weight: bold;
    color: white;
}

.clearfix {
    clear: both;
}

:deep(.is-wizard .e-items.e-toolbar-items) {
    display: flex;
}

:deep(.is-wizard .e-toolbar .e-toolbar-items .e-toolbar-item) {
    flex-grow: 10;
    flex-basis: 100px;
}

:deep(.is-wizard .e-toolbar .e-toolbar-items .e-toolbar-item:nth-child(2)),
:deep(.is-wizard .e-toolbar .e-toolbar-items .e-toolbar-item:last-child){
    flex-grow: 5;
}

:deep(.is-wizard .e-text-wrap), :deep(.is-wizard .e-tab-text), :deep(.is-wizard .e-tab-text > div), :deep(.is-wizard .e-tab-text > div > div) {
    width: 100%;
}

:deep(.e-tab .e-content) {
    min-height: 30px;
    padding: 10px;
}

:deep(.is-wizard .e-tab-header) {
    min-height: 50px !important;
}

:deep(.text-align-left) {
    text-align: left;
    width: 100%;
    display: block;
}

:deep(.text-align-right) {
    text-align: right;
    width: 100%;
    display: block;
}
</style>
